module.exports = __webpack_public_path__ + "static/media/angela_wang.bfbcfe74.png";